export default "__VITE_ASSET__837de017__"